import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { Clock, ArrowRight } from 'lucide-react';
export function UrgencySection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full px-6 py-10" data-id="element-291">
      <div className="max-w-3xl mx-auto" data-id="element-292">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.6
      }} data-id="element-293">
          <div className="flex items-center gap-4 mb-8" data-id="element-294">
            <Clock className="w-8 h-8 text-amber-gold" strokeWidth={1.5} data-id="element-295" />
            <h2 className="font-playfair text-3xl md:text-4xl font-bold" data-id="element-296">
              Urgencia Real: Esto no es un truco de marketing
            </h2>
          </div>

          <p className="text-lg md:text-xl mb-6" data-id="element-297">
            Cada noche que pasas sin las herramientas correctas es una noche que
            refuerza el bucle.
          </p>

          <p className="text-lg md:text-xl mb-6" data-id="element-298">
            La neurociencia es clara: cuanto más tiempo tu sistema nervioso
            permanece en modo alarma, más se refuerzan esas vías neurales. La
            ansiedad crónica no es un estado — es un hábito biológico que se
            consolida con cada día que pasa sin intervención.
          </p>

          <div className="my-12 text-center space-y-4" data-id="element-299">
            <p className="text-xl md:text-2xl font-playfair font-semibold" data-id="element-300">
              El mejor momento para empezar fue el año pasado.
            </p>
            <p className="text-2xl md:text-3xl font-playfair font-bold text-amber-gold" data-id="element-301">
              El segundo mejor momento es esta noche.
            </p>
          </div>

          <div className="my-16" data-id="element-302">
            <h3 className="font-playfair text-3xl md:text-4xl font-bold mb-8" data-id="element-303">
              La decisión
            </h3>

            <p className="text-lg md:text-xl mb-8" data-id="element-304">Tienes dos opciones.</p>

            <div className="space-y-6 mb-12" data-id="element-305">
              <div className="bg-red-900/20 border border-red-500/30 rounded-lg p-6" data-id="element-306">
                <p className="text-lg md:text-xl" data-id="element-307">
                  <span className="font-bold" data-id="element-308">Opción A:</span> Cierras esta
                  página, vuelves a lo mismo, y mañana te despiertas exactamente
                  igual que hoy.
                </p>
              </div>

              <div className="bg-amber-gold/20 border-2 border-amber-gold/50 rounded-lg p-6" data-id="element-309">
                <p className="text-lg md:text-xl" data-id="element-310">
                  <span className="font-bold" data-id="element-311">Opción B:</span> Das un paso — uno
                  solo — hacia un sistema nervioso que sabe cómo calmarse. Que
                  duerme profundo. Que no vive en alerta permanente.
                </p>
              </div>
            </div>

            <p className="text-xl md:text-2xl font-playfair font-semibold mb-4" data-id="element-312">
              No te pido que cambies tu vida de golpe.
            </p>
            <p className="text-xl md:text-2xl font-playfair font-semibold text-amber-gold mb-12" data-id="element-313">
              Te pido 15 minutos.
            </p>

            <motion.div initial={{
            opacity: 0,
            scale: 0.95
          }} animate={isInView ? {
            opacity: 1,
            scale: 1
          } : {
            opacity: 0,
            scale: 0.95
          }} transition={{
            delay: 0.4,
            duration: 0.5
          }} className="text-center" data-id="element-314">
              <motion.a href="https://dobolia.com/cart/64087943414109:1" target="_blank" rel="noopener noreferrer" whileHover={{
              scale: 1.02
            }} whileTap={{
              scale: 0.98
            }} className="bg-amber-gold text-dark-navy font-bold text-xl md:text-2xl px-12 py-8 rounded-full inline-flex items-center gap-4 shadow-2xl hover:shadow-amber-gold/30 transition-all no-underline" data-id="element-315">
                SÍ, QUIERO MI NEURO RESET SOMÁTICO + LOS DOS BONOS
                <ArrowRight className="w-7 h-7" strokeWidth={2.5} data-id="element-316" />
              </motion.a>
              <p className="text-warm-cream/60 mt-6" data-id="element-317">
                Acceso inmediato. Sin esperas. Empieza esta noche.
              </p>
            </motion.div>
          </div>
        </motion.div>
      </div>
    </section>;
}